import React, {useState, useEffect} from 'react';
import OffersService from '../Services/OffersService';
import { Button, Table, Form, Col, Row, FormGroup, Input, Label, CardHeader } from 'reactstrap';
import { Card, CardBody } from 'reactstrap';

const CostsPerTerms = () => {
    const [terms, setTerms] = useState([]);
    const [termPrices, setTermPrices] = useState([]);
    const [newTermPrices, setNewTermPrices] = useState([]);

    const offersService = new OffersService();
    useEffect(() => {
        offersService.getDeliveryTerms().then(r => {
            setTerms(r);
        });
        offersService.getTermPrices().then(r => {
            setTermPrices(r);
        });
    }, []);

    const savePrices = () => {
        offersService.createTermPrices(newTermPrices).then(() => {
            offersService.getTermPrices().then(r => {
                setTermPrices(r);
            });
        });
    }

    return <Card>
        <CardHeader>
            <h4>Όροι παράδοσης και κόστη ανά τόνο</h4>
        </CardHeader>
        <CardBody>
            <Table responsive>
                <thead>
                    <tr>
                        <th>Όρος</th>
                        <th>Κόστος ανά τόνο</th>
                    </tr>

                </thead>
                <tbody>
                    {
                        terms && terms.length > 0 && terms.map((term, index) => {
                            return <tr key={index}>
                                <th>{term.Code} - {term.Description}</th>
                                <td>
                                    <Input type="number" step="any" value={termPrices.find(tp => tp.term === term.Code) ? termPrices.find(tp => tp.term === term.Code).cost : 0} onChange={(e) => {
                                        setNewTermPrices([...newTermPrices.filter(tp => tp.term !== term.Code), {term: term.Code, cost: e.target.value}]);
                                        setTermPrices([...termPrices.filter(tp => tp.term !== term.Code), {term: term.Code, cost: e.target.value}]);
                                    }}/>
                                </td>
                            </tr>
                        })
                            
                    }
                </tbody>
                <tfoot>
                    <tr>
                        <td colSpan="2">
                            <Button block onClick={() => {
                                savePrices();
                            }}>Αποθήκευση</Button>
                        </td>
                    </tr>
                </tfoot>
            </Table>
        </CardBody>
    </Card>

};

export default CostsPerTerms;